<template>
  <div class="c-startpage-hero-template-dummy-triplet">
    <div class="grid grid-cols-7 gap-5">
      <div class="entry col-span-3">
        <div class="entry lg:h-[500px] w-full">
          <div class="flex flex-col gap-8 items-center w-full">
            <div class="w-full">
              <BasicSkeleton auto>
                <template #placeholder>
                <SkeletonElementImage class="w-full h-[500px]" />
                </template>
              </BasicSkeleton>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-6 items-center col-span-4">
        <div class="entry flex flex-col bg-white lg:h-[500px]">
          <div
            class="gap-8 justify-start h-1/2 items-center w-full bg-center bg-no-repeat bg-cover"
          >
            <BasicSkeleton auto>
              <template #placeholder>
                <SkeletonElementImage class="w-full h-[225px]" :img-style-classes="'w-full'" />
              </template>
            </BasicSkeleton>
          </div>
          <div
            class="flex flex-col justify-between gap-2 lg:gap-4 h-1/2 p-4 pt-2 w-full min-h-[250px]"
          >
            <BasicSkeleton auto>
              <template #placeholder>
                <div>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                </div>
              </template>
            </BasicSkeleton>
          </div>
        </div>
        <div class="entry flex flex-col bg-white lg:h-[500px]">
          <div
            class=" gap-8 justify-start h-1/2 items-center w-full bg-center bg-no-repeat bg-cover"
          >
              <BasicSkeleton auto>
              <template #placeholder>
                <SkeletonElementImage class="w-full h-[225px]" :img-style-classes="'w-full'" />
              </template>
            </BasicSkeleton>
          </div>
          <div
            class="flex flex-col justify-between gap-2 lg:gap-4 h-1/2 p-4 pt-2 w-full min-h-[250px]"
          >
            <BasicSkeleton auto>
              <template #placeholder>
                <div>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                  <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                </div>
              </template>
            </BasicSkeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const imagePlaceHolder = inject('ImagePlaceHolder') as string;
</script>
